import styles from "../../style.module.scss";
import useStore from "../../store/store";
import {useState} from "react";
import formatPrice from "../../utils/format-price";

const defaultText = 'Без снижения ответственности';

function Step3({number, insurances, links}) {
    const [open, setOpen] = useState(false);
    const ratesHide = useStore((state) => state.ratesHide)
    const currentInsurance = useStore((state) => state.currentInsurance)
    const setCurrentInsurance = useStore((state) => state.setCurrentInsurance)
    const getCurrentValue = () => {
        if (currentInsurance) {
            const insurance = insurances.filter((insurance) => insurance.caraddonid === currentInsurance);
            if (insurance && insurance[0]) {
                return insurance[0].caraddondocname;
            }
        }
        return defaultText;
    }
    if (!insurances) {
        return null;
    }

    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
            <div className={styles.newOrder__stepNumber}>
                {ratesHide ? number - 1 : number}
            </div>
            Выберите пакет снижения ответственности
            <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
            <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
        </div>
        {
            !!open && (
                <div className={styles.newOrder__stepContent}>
                    <div className={styles.insurances}>
                        <div className={styles.insurance} onClick={() => setCurrentInsurance(null)}>
                            <div className={`${styles.checkbox} ${!currentInsurance && styles.checked}`}/>
                            <span className='p-size'>{defaultText}</span>
                        </div>
                        {
                            insurances.map((item) => {
                                console.log(item)
                                return (<div key={item.caraddonid} className={styles.insurance}
                                             onClick={() => setCurrentInsurance(item.caraddonid)}>
                                    <div
                                        className={`${styles.checkbox} ${currentInsurance === item.caraddonid && styles.checked}`}/>
                                    <div className={`${styles.heading} p-size`}>
                                        {item.caraddondocname}
                                        {!!item?.caraddonrule && (<span className={`${styles.description}`}>{item.caraddonrule}</span>)}
                                        {
                                            !!item.caraddonprice && (<span>{formatPrice(item.caraddonprice,'/сут')}</span>)
                                        }
                                    </div>

                                </div>)
                            })
                        }
                    </div>
                    {
                        !!links?.insurance?.link && (
                            <a href={links.insurance.link} className={styles.moreButton} target='_blank'>Смотреть подробнее</a>)
                    }

                </div>
            )
        }

    </div>);
}

export default Step3;